import { render, staticRenderFns } from "./HEmphasisClarification.vue?vue&type=template&id=2b843870"
import script from "./HEmphasisClarification.vue?vue&type=script&lang=js"
export * from "./HEmphasisClarification.vue?vue&type=script&lang=js"
import style0 from "./HEmphasisClarification.vue?vue&type=style&index=0&id=2b843870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports